import React, { useEffect, useMemo, useState } from 'react';
import { format, parseISO } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoCloseCircleOutline } from "react-icons/io5";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const YearModal = ({ selectedYearEditing, globalState, globalRefs, setSelectedYearEditing, ResetMap }) => {

    const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    let selectedRange = globalState.selectedRange;
    let setSelectedRange = globalState.setSelectedRange;
    let selectedAggregate = globalState.selectedAggregate;
    let setSelectedAggregate = globalState.setSelectedAggregate;
    let selectedKey = globalState.selectedKey;
    let setLandKeySelectedKey = globalState.setLandKeySelectedKey;
    let selectedMetric = globalState.selectedMetric;
    let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
    let featureList = globalState.featureList;
    let activeFeatureId = globalState.activeFeatureId;
    let mapRef = globalRefs.mapRef;
    let mapMetaData = globalState.mapMetaData;
    let isYearRangeActive = globalState.isYearRangeOpen;
    let setIsYearRangeActive = globalState.setIsYearRangeOpen;
    let setSelectedMetric = globalState.setSelectedMetric;
    let availableValues = globalState.availableValues;
    let setSelectedKey = globalState.setSelectedKey;
    let availableKeys = globalState.availableKeys;
    let numericSummary = globalState.numericSummary;
    let setNumericSummary = globalState.setNumericSummary;
    let keySummary = globalState.keySummary;
    let setKeySummary = globalState.setKeySummary;
    let globalStartDate = globalState.globalStartDate;
    let setGlobalStartDate = globalState.setGlobalStartDate;
    let globalEndDate = globalState.globalEndDate;
    let setGlobalEndDate = globalState.setGlobalEndDate;
    let availableNumericMetrics = globalState.availableNumericMetrics;
    let setAvailableNumericMetrics = globalState.setAvailableNumericMetrics;
    let availableStringMetrics = globalState.availableStringMetrics;
    let setAvailableStringMetrics = globalState.setAvailableStringMetrics;
    let debugMode = globalState.debugMode;
    let setDebugMode = globalState.setDebugMode;
    let availableDates = globalState.availableDates;
    let setAvailableDates = globalState.setAvailableDates;
    let availableIDs = globalState.availableIDs;
    let setAvailableIDs = globalState.setAvailableIDs;

    let numericTimeAggregationMethod = globalState.numericTimeAggregationMethod;
    let setNumericTimeAggregationMethod = globalState.setNumericTimeAggregationMethod;

    const setLoadedPercentage = globalState.setLoadedPercentage;

    let LOADINGPARAM_applyDateRange = globalState.LOADINGPARAM_applyDateRange;
    let setLOADINGPARAM_applyDateRange = globalState.setLOADINGPARAM_applyDateRange;

    let LOADINGPARAM_resetMapAfterDatesReceived = globalState.LOADINGPARAM_resetMapAfterDatesReceived;
    let setLOADINGPARAM_resetMapAfterDatesReceived = globalState.setLOADINGPARAM_resetMapAfterDatesReceived;

    let [localSliderSelectedAggregate, setLocalSliderSelectedAggregate] = useState();

    const [scrubIndex, setScrubIndex] = useState(0);

    const MAX_SLIDER_OPTIONS = 40;
    const tooManyOptions = availableDates.length > MAX_SLIDER_OPTIONS;

    let singleFeatureEditMode = globalState.singleFeatureEditMode;

    const selectionColour =
        multuGroupSelectedArray?.length > 0 ? "#2964A8" : "#29645D";

    const selectionColourBackground =
        multuGroupSelectedArray?.length > 0
            ? "rgba(41, 100, 168, 0.2)"
            : "rgba(41, 100, 93, 0.2)";

    // NEW SLIDER STUFF BELOW

    // const marks = useMemo(() => {
    //     return availableDates.reduce((acc, y, i) => {
    //         const date = new Date(y);

    //         const day = String(date.getDate()).padStart(2, "0");
    //         const month = String(date.getMonth() + 1).padStart(2, "0");
    //         const year = String(date.getFullYear()).slice(-2);

    //         acc[i] = `${day}/${month}/${year}`;

    //         return acc;
    //     }, {});
    // }, [availableDates]);

    const toIsoWithOffset = (date) => {
        const d = new Date(date);
        const pad = (n) => String(n).padStart(2, '0');
        const year = d.getUTCFullYear();
        const month = pad(d.getUTCMonth() + 1);
        const day = pad(d.getUTCDate());
        const hours = pad(d.getUTCHours());
        const minutes = pad(d.getUTCMinutes());
        const seconds = pad(d.getUTCSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+00:00`;
    };

    let geoJSONReadyVersion = globalState.geoJSONReadyVersion;
    let setGeoJSONReadyVersion = globalState.setGeoJSONReadyVersion;


    // ------------------ Handlers ------------------

    const handleSelectDate = (date) => {
        console.log(date)
        setSelectedYearEditing(date);
    };

    const [clickerToReseteatureMarkers, setclickerToReseteatureMarkers] = useState(0);

    // ------------------ Render ------------------

    const [activeField, setActiveField] = useState(null); // "start" | "end"

    // ------------------ Extract Dates from the first feature and apply it to the inital date range ------------------

    const extractDatesFromAllSeries = (geojson) => {
        const features = geojson?.features;
        if (!Array.isArray(features) || features.length === 0) return [];

        const allKeys = new Set();

        for (const feature of features) {
            const ts = feature?.feature_data_simple_timeseries;
            if (!ts || typeof ts !== "object") continue;

            for (const series of Object.values(ts)) {
                if (!series || typeof series !== "object") continue;

                Object.keys(series).forEach(key => allKeys.add(key));
            }
        }

        return [...allKeys]
            .map(d => parseISO(d))
            .filter(Boolean)
            .sort((a, b) => a - b);
    };

    // const extractDatesFromLongestSeries = (geojson) => {
    //     const features = geojson?.features;
    //     if (!Array.isArray(features) || features.length === 0) return [];
    //     let longestSeriesKeys = [];
    //     for (const feature of features) {
    //         const ts = feature?.feature_data_simple_timeseries;
    //         if (!ts || typeof ts !== "object") continue;
    //         for (const series of Object.values(ts)) {
    //             if (!series || typeof series !== "object") continue;
    //             const keys = Object.keys(series);
    //             if (keys.length > longestSeriesKeys.length) {
    //                 longestSeriesKeys = keys;
    //             }
    //         }
    //     }
    //     return longestSeriesKeys
    //         .map(d => parseISO(d))
    //         .filter(Boolean)
    //         .sort((a, b) => a - b);
    // };

    useEffect(() => {
        if (!mapMetaData?.define_feature_data_simple_timeseries) return;
        const metaMetrics = mapMetaData.define_feature_data_simple_timeseries;
        const numericMetrics = [];
        const stringMetrics = [];

        Object.keys(metaMetrics).forEach(metric => {
            const meta = metaMetrics[metric];

            const hasData = longstandingGeoJSONRef.current?.features?.some(feature => {
                const series = feature.feature_data_simple_timeseries?.[metric];
                if (!series) return false;

                return Object.values(series).some(value => {
                    return (
                        value !== null &&
                        value !== undefined &&
                        value !== "" &&
                        value !== "No data available"
                    );
                });
            });

            if (!hasData) return;

            if (meta?.type === "number") {
                numericMetrics.push(metric);
            } else {
                stringMetrics.push(metric);
            }
        });

        setAvailableNumericMetrics(numericMetrics);
        setAvailableStringMetrics(stringMetrics);

    }, [
        mapMetaData,
        longstandingGeoJSONRef.current,
        selectedYearEditing
    ]);

    const applyDateRange = (nextStart, nextEnd) => {
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "🚀 [1] applyDateRange START");
        }
        if (!nextStart || !nextEnd) {
            if (debugMode) {

                const timestamp = new Date().toISOString();
                console.log(timestamp + " " + "❌ Missing start or end date");
            }
            return;
        }
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "📅 [2] Incoming Range", {
                nextStart,
                nextEnd,
            });
        }
        const allDates = extractDatesFromAllSeries(
            longstandingGeoJSONRef.current
        );
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "📦 [3] Extracted All Dates", {
                total: allDates.length,
                sample: allDates.slice(0, 3),
            });
        }
        const filteredDates = allDates.filter(
            d => d >= nextStart && d <= nextEnd
        );
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "🔍 [4] Filtered Dates", {
                total: filteredDates.length,
                sample: filteredDates.slice(0, 3),
            });
        }
        const formattedDates = filteredDates.map(d =>
            format(d, "yyyy-MM-dd'T'HH:mm:ssxxx")
        );
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "🧹 [5] Formatted Dates", {
                total: formattedDates.length,
                first: formattedDates[0],
                last: formattedDates[formattedDates.length - 1],
            });
        }
        const nextScrubIndex = 0;
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "🎚️ [6] Next Scrub Index", nextScrubIndex);
        }
        const nextSelectedYearEditing = formattedDates[0] ?? null;
        if (debugMode) {
            console.log(
                "📆 [7] Next Selected Year Editing",
                nextSelectedYearEditing
            );
        }

        const timeseriesMeta =
            mapMetaData?.define_feature_data_simple_timeseries ?? {};

        const getDisplayOrderApprovedItem = (items) => {
            return (
                [...(items ?? [])]
                    .filter(item => timeseriesMeta[item]?.display_order !== -1)
                    .sort((a, b) => a.localeCompare(b))
                [0] ?? null
            );
        };

        const nextSelectedValue = getDisplayOrderApprovedItem(availableValues);

        const nextSelectedKey = getDisplayOrderApprovedItem(availableKeys);

        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "🗝️ [9] Next Selected Key", nextSelectedKey);
            console.log(timestamp + " " + "⚡ [10] Applying React State Updates...");
        }
        setGlobalStartDate(nextStart);
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "✅ setGlobalStartDate");
        }
        setGlobalEndDate(nextEnd);
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "✅ setGlobalEndDate");
        }
        setSelectedRange([nextStart, nextEnd]);
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "✅ setSelectedRange");
        }
        setAvailableDates(formattedDates);
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "✅ setAvailableDates");
        }
        setScrubIndex(nextScrubIndex);
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "✅ setScrubIndex");
        }
        setLOADINGPARAM_applyDateRange(true)
    };

    useEffect(() => {
        if (
            !globalStartDate ||
            !globalEndDate ||
            !selectedYearEditing
        ) {
            return;
        }
        if (debugMode) {
            const timestamp = new Date().toISOString();
            console.log(timestamp + " " + "🏁 [12] resetting Map")
        }
        // 
        setLOADINGPARAM_resetMapAfterDatesReceived(true)
        ResetMap(globalRefs, globalState, () => {
            setTimeout(
                () => setclickerToReseteatureMarkers(t => t + 1),
                100
            );
        });
    }, [
        globalStartDate,
        globalEndDate,
        scrubIndex,
        selectedYearEditing,
        selectedMetric,
        selectedKey,
        numericTimeAggregationMethod
    ]);

    useEffect(() => {
        const geojson = longstandingGeoJSONRef.current;
        if (!geojson) return;
        const hasAvailableValues = Array.isArray(availableValues) && availableValues.length > 0;
        const hasAvailableKeys = Array.isArray(availableKeys) && availableKeys.length > 0;
        const allDates = extractDatesFromAllSeries(geojson);
        if (!allDates.length) return;
        applyDateRange(allDates[0], allDates[allDates.length - 1]);
    }, [geoJSONReadyVersion, availableValues, availableKeys]);

    const handleDateChange = (date) => {
        if (activeField === "start") {
            const nextStart = date;
            const nextEnd = globalEndDate && globalEndDate >= nextStart ? globalEndDate : nextStart;
            applyDateRange(nextStart, nextEnd);
        }
        if (activeField === "end") {
            const nextEnd = date;
            const nextStart = globalStartDate && globalStartDate <= nextEnd ? globalStartDate : nextEnd;
            applyDateRange(nextStart, nextEnd);
        }
        setActiveField(null);
    };

    // ESC key closes picker

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                setActiveField(null);
            }
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [setActiveField]);

    useEffect(() => {
        if (activeField) {
            setIsYearRangeActive(true);
        } else {
            setIsYearRangeActive(false);
        }
    }, [activeField, setIsYearRangeActive]);

    // 

    const aggregateDateUTC = (date, method) => {
        const d = new Date(date);

        switch (method) {
            case "year":
                return new Date(Date.UTC(
                    d.getUTCFullYear(),
                    0,
                    1
                ));

            case "month":
                return new Date(Date.UTC(
                    d.getUTCFullYear(),
                    d.getUTCMonth(),
                    1
                ));

            case "day":
                return new Date(Date.UTC(
                    d.getUTCFullYear(),
                    d.getUTCMonth(),
                    d.getUTCDate()
                ));

            case "hour":
                return new Date(Date.UTC(
                    d.getUTCFullYear(),
                    d.getUTCMonth(),
                    d.getUTCDate(),
                    d.getUTCHours()
                ));

            default:
                return d;
        }
    };

    const aggregatedDates = useMemo(() => {
        const map = new Map();

        availableDates.forEach(date => {
            const bucketDate = aggregateDateUTC(
                date,
                numericTimeAggregationMethod
            );

            const key = bucketDate.getTime();

            if (!map.has(key)) {
                map.set(key, bucketDate);
            }
        });

        return [...map.values()].sort((a, b) => a - b);

    }, [availableDates, numericTimeAggregationMethod]);

    const marks = useMemo(() => {
        return Object.fromEntries(
            aggregatedDates.map((date, index) => {
                const d = new Date(date);
                let label;

                switch (numericTimeAggregationMethod) {
                    case "year":
                        label = d.getUTCFullYear();
                        break;

                    case "month":
                        label = d.toLocaleString("default", {
                            month: "short",
                            year: "2-digit",
                            timeZone: "UTC"
                        });
                        break;

                    case "day":
                        label = d.toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            timeZone: "UTC"
                        });
                        break;

                    case "hour":
                        label = d.toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                            timeZone: "UTC"
                        });
                        break;
                }

                return [index, label];
            })
        );
    }, [aggregatedDates, numericTimeAggregationMethod]);

    useEffect(() => {
        if (!aggregatedDates.length) return;

        const now = Date.now();

        const closestDate = aggregatedDates.reduce((closest, current) => {
            const currentDiff = Math.abs(current.getTime() - now);
            const closestDiff = Math.abs(closest.getTime() - now);

            return currentDiff < closestDiff ? current : closest;
        });

        console.log(selectedYearEditing)

        if (!selectedYearEditing) {
            setSelectedYearEditing(toIsoWithOffset(closestDate));
        }

    }, [aggregatedDates]);

    //

    return (
        <div style={{
            position: 'fixed',
            backgroundColor: 'white',
            zIndex: 1000,
            display: singleFeatureEditMode === 1 ? 'none' : 'block',
            width: '100%',
            borderBottom: '1px solid #ccc',
        }}>
            <div
                className="modalBackdrop"
                style={{ backgroundColor: "#fff", padding: "0px 30px", width: "95%" }}
            >
                <div
                    className="modalContent"
                    style={{ display: 'none' }}
                    onClick={(e) => e.stopPropagation()}
                >

                    <div style={{ display: "flex", gap: "70px", marginTop: "5px" }}>
                        {/* START INPUT */}
                        <div style={{
                            fontSize: "10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                            marginBottom: "5px"
                        }}>
                            <input
                                readOnly
                                value={globalStartDate ? globalStartDate.toLocaleString() : ""}
                                placeholder="Select start date"
                                onClick={() => setActiveField("start")}
                                style={{ cursor: "pointer", fontSize: "10px", border: activeField === "start" ? "1px solid #333" : "1px solid #ccc", padding: "6px", borderRadius: "4px" }}
                            />
                        </div>
                        {/* END INPUT */}
                        <div style={{
                            fontSize: "10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px"
                        }}>
                            <input
                                readOnly
                                value={globalEndDate ? globalEndDate.toLocaleString() : ""}
                                placeholder="Select end date"
                                onClick={() => setActiveField("end")}
                                style={{ cursor: "pointer", fontSize: "10px", border: activeField === "end" ? "1px solid #333" : "1px solid #ccc", padding: "6px", borderRadius: "4px" }}
                            />
                        </div>
                    </div>
                    {/* SINGLE SHARED PICKER */}
                    {activeField && (
                        <div style={{ position: "relative", display: "inline-block" }}>
                            {/* CLOSE BUTTON */}
                            <button
                                onClick={() => setActiveField(null)}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    right: -25,
                                    zIndex: 10,
                                    fontSize: "16px",
                                    cursor: "pointer"
                                }}
                            >
                                <IoCloseCircleOutline />
                            </button>
                            <DatePicker
                                selected={
                                    activeField === "start" ? globalStartDate : globalEndDate
                                }
                                onChange={handleDateChange}
                                selectsStart={activeField === "start"}
                                selectsEnd={activeField === "end"}
                                startDate={globalStartDate}
                                endDate={globalEndDate}
                                minDate={activeField === "end" ? globalStartDate : null}
                                showTimeSelect
                                inline
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* Aggregate Selector */}
            <div
                style={{
                    display: "flex",
                    // top: "-1px",
                    marginLeft: "10px",
                    marginRight: "10px",
                    border: `1px solid ${selectionColour}`,
                    borderRadius: "3px",
                    overflow: "hidden",
                    marginTop: '-1.5px',
                }}
            >
                {["year", "month", "day", "hour"].map(agg => {
                    const isActive = numericTimeAggregationMethod === agg;

                    return (
                        <button
                            key={agg}
                            className={`aggregationSelectionButton ${isActive ? 'is-active' : 'is-inactive'}`}
                            onClick={() => setNumericTimeAggregationMethod(agg)}
                            style={{
                                flex: 1,
                                paddingTop: "9px",
                                paddingBottom: "9px",
                                paddingLeft: "8px",
                                paddingRight: "8px",
                                border: "none",
                                background: isActive
                                    ? selectionColour
                                    : selectionColour === "#2964A8"
                                        ? "#E3ECF6"
                                        : "#DEEFE7",
                                color: isActive ? "#fff" : selectionColour,
                                fontSize: "10px",
                                cursor: "pointer"
                            }}
                        >
                            {agg.charAt(0).toUpperCase() + agg.slice(1)}
                        </button>
                    );
                })}
            </div>

            {/* SLIDER */}

            <div className="modalBackdrop" style={{
                backgroundColor: '#fff',
                padding: '0px 0px 0px 15px',
                marginTop: '20px',
                width: '100%',
                height: '60px'
                // display: 'none'
            }}>
                <Slider
                    className={`timestamp-slider ${multuGroupSelectedArray?.length > 0 ? "slider-blue" : "slider-green"} ${globalState.isLeftSubDrawerOpen ? "slider-scenario" : ""}`}
                    style={{
                        top: "0px",
                        width: "335px",
                        left: "5px"
                    }}
                    min={0}
                    max={Math.max(0, aggregatedDates.length - 1)}
                    value={Math.max(
                        0,
                        aggregatedDates.findIndex(
                            d =>
                                new Date(d).getTime() ===
                                new Date(selectedYearEditing).getTime()
                        )
                    )}
                    marks={Object.fromEntries(
                        Object.entries(marks).map(([key, value]) => [
                            key,
                            {
                                label: (
                                    <div
                                        style={{
                                            transform: "rotate(-45deg)",
                                            whiteSpace: "nowrap",
                                            fontSize: "8px",
                                            marginTop: "10px"
                                        }}
                                    >
                                        {value}
                                    </div>
                                )
                            }
                        ])
                    )}
                    step={1}
                    onChange={val => {
                        const flam = toIsoWithOffset(aggregatedDates[val]);
                        setSelectedYearEditing(flam);
                    }}
                />
            </div>
        </div>
    );
};

export default YearModal;
